import { useNavigate, useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useAuthContext } from "../../../hooks/useAuthContext";
import CourseDetailComponent from "./components/CourseDetailComponent";
import coursesAPI from "../../../services/courses";
import MeaPageTitle from "../../../components/MeaPageTitle";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import { useRef, useState } from "react";
import { TabMenu } from "primereact/tabmenu";
import ScheduleListComponent from "../schedule/components/ScheduleListComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import UpdateCourseModal from "./components/UpdateCourseModal";
import { PERMISSION_TRAINING_COURSES } from "../../../permissions";

const CourseDetailPage = () => {
  const { hasPermission } = useAuthContext();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const toast = useRef();
  const navigate = useNavigate();
  const courseId = params.courseId;
  //
  const courseQuery = coursesAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    courseId
  );
  const courseObj = courseQuery?.data?.data;
  //
  //
  // states
  const [activeItem, setActiveItem] = useState(0);
  const listRef = useRef();
  // params
  const items = [{ label: "Programme de la semaine", icon: "pi pi-clock" }];
  //
  return (
    <>
      <MeaPage
        showBackButton={true}
        title={<MeaPageTitle prefix={"Matière:"} title={courseObj?.name} />}
        actions={[
          {
            label: "Modifier",
            icon: "pi pi-file-edit",
            disable: !hasPermission(PERMISSION_TRAINING_COURSES.UPDATE),
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  courseQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !hasPermission(PERMISSION_TRAINING_COURSES.UPDATE),
          },
          {
            label: "Supprimer",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_TRAINING_COURSES.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer cette matière?",
                header: "Confirmation",
                icon: "pi pi-info-circle",
                defaultFocus: "reject",
                acceptClassName: "p-button-danger",
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  coursesAPI
                    .DeleteOne(schoolId, trainingId, accessToken, courseId)
                    .then((data) => {
                      toast.current.show({
                        severity: "success",
                        summary: "Succès",
                        detail: courseObj?.name + " Supprimée!",
                        life: 3000,
                      });
                      navigate(
                        "/school/" + schoolId + "/admin/trainings/" + trainingId + "/courses"
                      );
                    })
                    .catch((error) => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              });
            },
          },
        ]}
      >
        <CourseDetailComponent course={courseObj} />
        <UpdateCourseModal ref={updateModalRef} course={courseObj} schoolId={schoolId} trainingId={trainingId} accessToken={accessToken} />
        <ConfirmDialog />
        <Toast ref={toast} />

        <div className="mt-5">
          <TabMenu
            model={items}
            activeIndex={activeItem}
            onTabChange={(e) => {
              setActiveItem(e.index);
            }}
          />
          {activeItem === 0 && (
            <MeaLoadingContent objectQuery={courseQuery}>
              <ScheduleListComponent
                ref={listRef}
                schoolId={schoolId}
                trainingId={trainingId}
                filter={{ course_id: courseObj?.id }}
                showAddButton={false}
                showFilterButton={false}
                selectedFields={{
                  course: false,
                }}
              />
            </MeaLoadingContent>
          )}
        </div>
      </MeaPage>
    </>
  );
};
export default CourseDetailPage;
